import { appendIf } from '@btime/helpers'
import { colors } from '@btime/constants'
import { useTranslation } from 'react-i18next'

import { useColors } from '../../../packages/kiti/components/theme/_hooks/colors'
import {
  useIntegrationLogsAction,
  useIntegrationReinstallAction,
  useIntegrationRemoveAction,
  useIntegrationsLogsAction,
  useIntegrationsRemoveAction,
  useIntegrationsAddSegwareTechnicianAction,
  useIntegrationsListTechniciansAction
} from './actions'
import { prop } from 'ramda'

const useSingleActions = (item, opts) => {
  const { t } = useTranslation('common')
  const hide = opts.hide || []
  const colors = useColors()

  const reinstall = useIntegrationReinstallAction(item)
  const logs = useIntegrationLogsAction(item)
  const remove = useIntegrationRemoveAction(item)
  const addSegwareTechnician = useIntegrationsAddSegwareTechnicianAction(item)
  const ListSegwareTechnicians = useIntegrationsListTechniciansAction(item)

  return [
    // ...appendIf(!hide.includes('seeDetails'), {
    //   value: 'Ver detalhes',
    //   icon: 'RiSearchLine',
    //   onClick: details.click
    // }),

    ...appendIf(logs.hasPermission, {
      value: t('logs'),
      icon: 'RiTimeLine',
      onClick: logs.click,
      to: logs.link
    }),

    ...appendIf(reinstall.hasPermission, {
      value: t('reinstall'),
      icon: 'RiInstallLine',
      onClick: reinstall.click
    }),

    ...appendIf(addSegwareTechnician.hasPermission, {
      value: t('registerTechnician'),
      icon: 'RiUserAddLine',
      onClick: addSegwareTechnician.click
    }),

    ...appendIf(ListSegwareTechnicians.hasPermission, {
      value: t('viewTechnicians'),
      icon: 'RiUserLine',
      onClick: ListSegwareTechnicians.click
    }),

    ...appendIf(remove.hasPermission, {
      value: t('remove'),
      icon: 'RiDeleteBin2Line',
      color: colors.red,
      onClick: remove.click
    })
  ]
}

const useMultiActions = (items, opts) => {
  const { t } = useTranslation('common')
  const hide = opts.hide || []
  const colors = useColors()

  // const newServiceOrder = useIntegrationNewServiceOrderActions(items)
  const logs = useIntegrationsLogsAction(items)

  const remove = useIntegrationsRemoveAction(items)

  return [
    ...appendIf(logs.hasPermission, {
      value: t('logs'),
      icon: 'RiTimeLine',
      onClick: logs.click,
      to: logs.link
    }),

    ...appendIf(remove.hasPermission, {
      value: t('remove'),
      color: colors.red,
      icon: 'BsTrash',
      onClick: remove.click
    })
  ]
}

export const useIntegrationActionsList = (item, items, opts = {}) => {
  const singleOptions = useSingleActions(item, opts)

  const ids = items?.map(prop('id'))

  const multiOptions = useMultiActions(ids, opts)

  return [!items || items.length === 1 ? singleOptions : multiOptions, false]
}
